export default "__VITE_ASSET__D9MtL$gR__"